import React from "react";
import { useEffect, useState } from "react"
import { Loading } from "../../../components/Loading";
import sharedDatas from "../../../businessLogic/sharedDatas";
import VaporPage from "@vapor/react-custom/VaporPage";
import Grid from "@vapor/react-material/Grid";
import { NoData } from "../../../components/NoData";
import {
    DataGridPro,
    GridToolbar,
    itIT,
} from "@mui/x-data-grid-pro";
import VaporTag from "@vapor/react-custom/VaporTag";

//oneFront SDK
import {    
    useSnackbar,
    useTranslation
} from "@1f/react-sdk";
import { ExtendedTabs, ExtendedTab } from "@vapor/react-extended";
import { userPermissionModel } from "../../../businessLogic/models";
import { pathNominationHome } from "../../../businessLogic/constants/path";
import { bsaSettingsNominations } from "../../../businessLogic/constants/securityAreas";
import { chipGreen, chipRed } from "../../../businessLogic/styles";
import { Add as AddIcon, DeleteOutlineOutlined as DeleteIcon, ArrowForward as DetailIcon } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@vapor/react-material";
import { ModalNominationAdd } from "./ModalNominationAdd";
import { ModalDelete } from "../../../components/ModalDelete";
import { NotAuth } from "../../../components/NotAuth";
import { LogApi } from "../../../businessLogic/api/logApi";
import { LastActivityApi } from "../../../businessLogic/api/lastActivityApi";
import { UserRolesApi } from "../../../businessLogic/api/userRolesApi";
import { useNavigate } from "react-router-dom";
import { DateHelpers } from "../../../businessLogic/helpers/dateHelpers";

export const NominationHome = () => {    
    const tenantId = sharedDatas.getPropertyByName("tenantId");    
    const aziendaId = sharedDatas.getPropertyByName("aziendaId");
    const loggedUserId = sharedDatas.getPropertyByName("userId");    
    const { t } = useTranslation();    
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    //#region Api
    const logApi = LogApi();
    const userRolesApi = UserRolesApi();
    const lastActivityApi = LastActivityApi(); 
    const dateHelpers = DateHelpers();
    //#endregion

    //Definizione delle colonne della tabella
    const dataColumns = [
        { field: "userId", headerName: "userId", flex: 0.2, hidden : true  },
        {
            field: "email",
            headerName: t("impostazioni.utenti.form.email"),
            flex: 0.5,
            editable: false,
            valueGetter: (params) => params.row.user?.email || ""
        },
        {
            field: "firstName",
            headerName: t("impostazioni.utenti.form.name"),
            flex: 0.3,
            editable: false,
            valueGetter: (params) => params.row.user?.firstName || ""
        },
        {
            field: "surname",
            headerName: t("impostazioni.utenti.form.surname"),
            flex: 0.3,
            editable: false,
            valueGetter: (params) => params.row.user?.surname || ""
        },       
        {
            field : "dateStart",
            headerName: "Data inizio ruolo",
            flex:0.2,
            editable:false,
            valueGetter: (params) => new Date(params.row.user?.roleStartDate).toLocaleDateString() || ""
        },
        {
            field : "dateEnd",
            headerName: "Data fine ruolo",
            flex:0.2,
            editable:false,
            valueGetter: (params) => params.row.user?.roleEndDate !== null ? new Date(params.row.user?.roleEndDate).toLocaleDateString() || "" : ""
        },
        {
            field : "status",
            headerName: "Stato",
            flex:0.2,
            editable:false,
            renderCell: (params) => renderColorCell(params.row.user?.status || ""),
            valueGetter : (params) => renderColorCellGetter(params.row.user?.status || "")
        },
        {
            field: "actions",
            headerName: "",
            flex: 0.2,
            filterable: false,
            renderCell: (params) =>
                renderEditButton(params.row),
        },
    ]
    
    //#region UseState  
    const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
    const [selectedRole, setSelectedRole] = useState("responsabile_antiriciclaggio")
    const [usersList,setUsersList] = useState([])
    const [showAddModal,setShowAddModal] = useState(false)
    const [preSelectedUser,setPreSelectedUser] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false); //Modal per la conferma di eliminazione di un record
    const [userPermissions,setUserPermissions] = useState(new userPermissionModel(
        0,
        aziendaId,
        bsaSettingsNominations,
        false,
        false,
        false,
        false
    ))
    //#endregion

    //#region Render
    const renderColorCell = (status)=>{
        if(!status){
            return <VaporTag variant='standard' label='Cessato' sx={chipRed} />;
        } else {
            return <VaporTag variant='standard' label='Attivo' sx={chipGreen} />;
        }
    }
    const renderColorCellGetter = (status) => {
        if(!status){
            return "Cessato"
        } else {
            return "Attivo"
        }
    }
    const renderEditButton = (itemToedit)=>{
        return (
            <Stack direction="row" spacing={0}>
                {userPermissions.canDelete &&
                    <IconButton
                        color='error'
                        onClick={(e) => handleDeleteRole(e, itemToedit)}
                    >
                        <DeleteIcon />
                    </IconButton>                
                }
                {userPermissions.canUpdate &&
                    <IconButton
                        color="primary"
                        onClick={(e) => handleOpenEditModal(e,itemToedit)}
                    >
                        <DetailIcon />
                    </IconButton>
                }
            </Stack>
        );
    }
    //#endregion

    useEffect(()=>{
        if(
            tenantId === "" || 
            aziendaId === 0 ||
            loggedUserId === ""                 
        ){
            navigate("/")
        } else {
            /**************************************/
            //Carico i permessi relativi all'utente
            setUserPermissions(
                sharedDatas
                .getPropertyByName("userPermissions")
                .filter((x) => x.area === bsaSettingsNominations)[0]
            );
            manageLastActivity()        
            loadNominationRoles()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedRole,showAddModal,showDeleteModal])

    async function loadNominationRoles(){
        try {            
            setBackDropOpen(true)
            let roles = await userRolesApi.GetUserRoles()
            let roleDetails = await userRolesApi.GetUserRolesDetails()                                    
            let roleComplete = roles.map(role=>{
                // Match più preciso: userId, dateStart E role
                const matchingDetail = roleDetails.find(detail => 
                    detail.userId === role.userId && 
                    detail.roleStartDate === role.dateStart &&
                    detail.role === role.role
                );
                
                return {
                    ...role,
                    user : matchingDetail ?? null,
                }
            })
            setUsersList(roleComplete.filter(p=>p.role === selectedRole))
        } catch (error) {
            logApi.AddLog(error.message,error.stack,"LoadNominationRoles", "NominationHome")
            enqueueSnackbar(error.message,{variant:"error",autoHideDuration: 8000})             
        } finally {
            setBackDropOpen(false)
        }
    }
    async function manageLastActivity() {
        try {
            await lastActivityApi.UpdateLastActivity(pathNominationHome)
        } catch (error) {
            logApi.AddLog(error.message,error.stack,"manageLastActivity", "NominationHome")            
        }                            
    }
    //#region handlers
    const handleChangeTab = (event,newValue) => {
        setSelectedRole(newValue)
    }
    const handleAddNew = ()=>{
        setPreSelectedUser(null)
        setShowAddModal(true)
    }
    const handleModalAddOk = async (selUser,startDate,endDate,selectedRole,sosUserDateRegUif) => {
        try {                                                   
            if(preSelectedUser !== null && preSelectedUser.userId === selUser.userId){ 
                //Aggiorno il ruolo
                try {                 
                    if(preSelectedUser.user?.status || (usersList.filter(record=>record.user?.status)[0]?.user?.userId ?? preSelectedUser.userId) === preSelectedUser.userId){
                        await userRolesApi.UpdateUserRole(preSelectedUser.id,{                    
                            id : preSelectedUser.id,
                            tenantId : tenantId,
                            userId : selUser.userId,
                            role : preSelectedUser.user.role,
                            dateStart : dateHelpers.FormatToUTCWithoutTimezone(startDate,false),
                            dateEnd: endDate && endDate !== "" ? dateHelpers.FormatToUTCWithoutTimezone(endDate,false) : null,
                            aziendaId:aziendaId,
                            sosUserDateRegUif : sosUserDateRegUif ? dateHelpers.FormatToUTCWithoutTimezone(new Date(sosUserDateRegUif),false) : null             
                        })
                    } else {
                        throw new Error("Impossibile aggiornare i dati dell'utente cessato se presente un utente attivo per lo stesso ruolo");
                    }
                } catch (error) {
                    logApi.AddLog(error.message,error.stack,"handleModalAddOk/UpdateUserRole", "NominationHome")
                    enqueueSnackbar(error.message,{variant:"error",autoHideDuration: 8000})  
                    return  
                }
                enqueueSnackbar("Aggiornamento avvenuto con successo",{variant:"success"})
            } else { 
                //Creo il ruolo                            

                //Controllo se l'utente in salvataggio ha già il ruolo che si sta aggiungendo in stato attivo e nel caso torno un errore
                let sameUser = usersList.filter(p=>p.userId === selUser.userId)[0]
                if(sameUser && sameUser.roleActive && sameUser.type === selectedRole){
                    enqueueSnackbar("L'utente selezionato ha già una nomina attiva per il ruolo selezionato",{variant:"error"})
                    return
                }                                

                try {                
                    await userRolesApi.PostUserRole({
                        id : 0,
                        tenantId : tenantId,
                        userId : selUser.userId,
                        role : selectedRole === "Referente SOS" ? "sos_referente" : selectedRole === "Responsabile antiriciclaggio" ? "responsabile_antiriciclaggio" : "revisore_indipendente",
                        dateStart : dateHelpers.FormatToUTCWithoutTimezone(startDate,false),
                        dateEnd : endDate ? dateHelpers.FormatToUTCWithoutTimezone(endDate,false) : null,
                        aziendaId:aziendaId,
                        sosUserDateRegUif : sosUserDateRegUif ? dateHelpers.FormatToUTCWithoutTimezone(new Date(sosUserDateRegUif),false) : null
                    })
                } catch (error) {
                    logApi.AddLog(error.message,error.stack,"handleModalAddOk/PostUserRole", "NominationHome")
                    enqueueSnackbar(error.message,{variant:"error",autoHideDuration: 8000})  
                    return                      
                }
                        
                enqueueSnackbar("Salvataggio avvenuto con successo",{variant:"success"})
            }
        } catch (error) {
            logApi.AddLog(error.message,error.stack,"handleModalAddOk", "NominationHome")
            enqueueSnackbar("Si è verififcato un errore durante il salvataggio dei dati",{variant: "error"})
        } finally {            
            setShowAddModal(false)
        }
    }
    const handleModalAddClose = () => {
        setPreSelectedUser(null)
        setShowAddModal(false)
    }
    const handleOpenEditModal = (e,itemToedit) =>{
        if(userPermissions.canUpdate){
            e.stopPropagation();
            setPreSelectedUser(itemToedit)
            setShowAddModal(true)
        }
    }
    const handleDeleteRole = (e,itemToDelete) => {
        e.stopPropagation();
        setPreSelectedUser(itemToDelete);
        setShowDeleteModal(true);
    }
    const handleModalDeleteClose = () => {
        setPreSelectedUser(null)
        setShowDeleteModal(false);
    };
    const handleModalDeleteOkClick = async () => {
        try {
            await userRolesApi.DeleteUserRole(preSelectedUser.id)
            enqueueSnackbar("Eliminazione avvenuta con successo", { variant: "success" });            
        } catch (e) {
            logApi.AddLog(e.message,e.stack,"handleModalDeleteOkClick", "NominationHome")      
            enqueueSnackbar("si è verificato un errore durante l'eliminazione", { variant: "error" });
        } finally {
            setPreSelectedUser(null)
            setShowDeleteModal(false)
        }
    };
    //#endregion
    
    //#region Return graphics
    return(
        <VaporPage
            title="Ruoli"
            headerLeft={
                <Button
                    variant='text'
                    size='medium'
                    endIcon={<AddIcon />}
                    color='primary'
                    disabled
                    tabIndex={-1}
                    aria-hidden='true'
                    sx={{ mr: 2, visibility: "hidden", pointerEvents: "none" }}
                    >
                    Nomina
                </Button>
            }
            headerRight={
                <Button
                    variant='text'
                    size='medium'
                    endIcon={<AddIcon />}
                    color='primary'
                    onClick={handleAddNew}
                    disabled={!userPermissions.canCreate}
                    sx={{ mr: 2 }}
                    >
                    Nomina
                </Button>
            }
        >        

            <Loading open={backDropOpen} />
            
            {showDeleteModal ? (
                <ModalDelete
                    show={showDeleteModal}
                    onClose={handleModalDeleteClose}
                    onOk={handleModalDeleteOkClick}
                    deleteMessage={t("modal.deleteDesc")}
                ></ModalDelete>
            ) : null}

            <ModalNominationAdd
                tenantId={tenantId}
                show={showAddModal}
                userFromParent = {preSelectedUser}
                selectedRoleFromParent = {selectedRole}
                onClose={handleModalAddClose}
                onOk={handleModalAddOk}                
            />  
            {!userPermissions.canRead ? <NotAuth /> : (                                                                   
                <VaporPage.Section>
                    <ExtendedTabs
                        variant="standard"
                        size="small"
                        value={selectedRole}
                        onChange={handleChangeTab}
                        sx={{ mb: 2 }}
                    >                    
                        <ExtendedTab
                            value="responsabile_antiriciclaggio"
                            label="Responsabili antiriciclaggio"
                        />
                        <ExtendedTab 
                            value="revisore_indipendente" 
                            label="Revisori indipendenti" 
                        />
                        <ExtendedTab
                            value="sos_referente"
                            label="Referenti SOS"
                        />
                    </ExtendedTabs>

                    <Grid container>
                        <Grid item xs={12} sx={{ width: "100%" }}>
                            {usersList.length > 0 ? (
                            <DataGridPro
                                rows={usersList}
                                columns={dataColumns}
                                getRowId={(row) => row.id}
                                slots={{ toolbar: GridToolbar }}
                                autoHeight={true}
                                pageSizeOptions={[25, 50, 100]}
                                localeText={
                                itIT.components.MuiDataGrid.defaultProps.localeText
                                }
                                pagination
                                onRowClick={(params,e)=> handleOpenEditModal(e,params.row)}                            
                                initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        userId: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: {
                                    pageSize: 25,
                                    },
                                },
                                }}
                                slotProps={{
                                toolbar: { printOptions: { disableToolbarButton: true } },
                                }}
                            />
                            ) : (
                            <NoData />
                            )}
                        </Grid>
                </Grid>
                </VaporPage.Section>        
            )}

        </VaporPage>
    )
    //#endregion
}